import GuestEmptyCartDealerEsiteOptions from './GuestEmptyCartDealerEsiteOptions';
import { ConsentAcceptanceModalContext } from '@app/components/common/ConsentAcceptanceModalContext';

const GuestSignIn = () => {
  return (
    <ConsentAcceptanceModalContext>
      <div className="d-print-none">
        <GuestEmptyCartDealerEsiteOptions />
      </div>
    </ConsentAcceptanceModalContext>
  );
};

export default GuestSignIn;
